module.exports = __webpack_public_path__ + "img/multiGreen.727c95ba.jpg";